<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <sh-form-select-base
        [id]="controlId"
        [style]="style"
        [formControl]="control"
        [options]="options"
        [required]="isControlRequired$ | async"
        [showEmptyOption]="showEmptyOption"
        [emptyOptionLabel]="emptyOptionLabel"
        [title]="disabledMsg || ''"
        [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
        [attr.aria-invalid]="isControlInvalid$ | async"
        class="sh-form-group__input"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
    ></sh-form-select-base>
</sh-form-group>
